// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3zXxq","bigColWidth":"Table_bigColWidth__3IdoO","biggerColWidth":"Table_biggerColWidth__iduBg","row":"Table_row__r_Jw2","col":"Table_col__3MklS"};